import * as yup from 'yup';

const auth0Validation = yup.object().shape({
  name: yup.string().trim().required(),
  loginKey: yup.string().trim().email().required(),
  loginType: yup.string().required(),
});

export default auth0Validation;
